export const SET_JSON_FORM = "FETCH_JSON_FORM";

export function setJsonForm(status) {
  return {type: SET_JSON_FORM, status};
}
